import { MessageSquareHeart, UsersRound, PlusCircle } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const CARDS = [
  {
    icon: MessageSquareHeart,
    title: "Demandes de dernière minute",
    text: "Discours, surprises, diaporamas : transmettez-nous vos fichiers et consignes au plus tard 48 heures avant l'événement. Passé ce délai, nous ferons notre possible, sans pouvoir le garantir.",
    testId: "info-card-last-minute",
  },
  {
    icon: UsersRound,
    title: "Deux contacts référents",
    text: "Pour préserver la magie des surprises, désignez deux contacts référents — témoins ou proches. Ils seront nos seuls interlocuteurs pour coordonner discours et animations secrètes : vous, vous ne gérez rien.",
    testId: "info-card-contacts",
  },
  {
    icon: PlusCircle,
    title: "Des options sur devis",
    text: "Étincelles froides, fumée lourde, éclairage architectural, sonorisation de cérémonie… Dites-nous tout : chaque option fait l'objet d'un devis dédié, chiffré et validé avant le jour J.",
    testId: "info-card-options",
  },
];

export default function PracticalInfo() {
  return (
    <section id="infos" className="relative bg-[#0A101B] py-28 sm:py-36" data-testid="practical-info-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          testId="practical-info-heading"
          eyebrow="Organisation & imprévus"
          title={
            <>
              Tout est cadré, <span className="text-gradient">tout est écrit.</span>
            </>
          }
          text="Une organisation transparente, pour que le jour J ne soit que du plaisir."
        />

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.12} className="h-full">
              <div
                className="group h-full rounded-3xl border border-cyan-500/15 bg-[#0E1524]/70 p-8 backdrop-blur-xl transition-colors duration-500 hover:border-cyan-400/40"
                data-testid={c.testId}
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-cyan-400/25 bg-cyan-400/10 transition-transform duration-500 group-hover:scale-110">
                  <c.icon size={22} className="text-cyan-300" />
                </div>
                <h3 className="font-display mt-6 text-xl font-bold text-slate-100">{c.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
